/* CzechMovie: tocici se kolecko v tlacitku "Add to cart" behem pridavani (2026-10-05).
 *
 * Stejne chovani jako na CzechiaFood (Dawn): tlacitko zesedne (pruhlednost 50 %), text zustane
 * videt a pres nej se toci kolecko (stejna SVG animace jako Dawn), dokud se zbozi nepridava.
 * Bocni kosik (mini-cart drawer) zustava beze zmeny.
 *
 * Tema (Warehouse) pri pridani do kosiku vysila 'theme:loading:start' / 'theme:loading:end'
 * (stranka produktu, rychly nahled, dlazdice kolekci, darkove baleni v kosiku). Kolecko
 * zapneme jen na tlacitku, na ktere se prave kliklo; kdyz tema pridavani nespusti
 * (napr. nevyplneny formular), loading:start neprijde a nic se nezobrazi.
 */
(function () {
  var style = document.createElement('style');
  style.textContent =
    '.cm-atc-loading{position:relative!important;opacity:.5!important;pointer-events:none;cursor:progress}' +
    '.cm-atc-spinner{position:absolute;top:50%;left:50%;width:18px;height:18px;margin:-9px 0 0 -9px;' +
    'display:flex;align-items:center;justify-content:center;z-index:1;pointer-events:none}' +
    '.cm-atc-spinner svg{width:18px;height:18px;animation:cm-atc-rotator 1.4s linear infinite}' +
    '.cm-atc-spinner circle{fill:none;stroke:var(--cm-atc-color,#fff);stroke-width:6;stroke-dasharray:280;' +
    'stroke-dashoffset:0;transform-origin:center;animation:cm-atc-dash 1.4s ease-in-out infinite}' +
    '@keyframes cm-atc-rotator{0%{transform:rotate(0)}100%{transform:rotate(270deg)}}' +
    '@keyframes cm-atc-dash{0%{stroke-dashoffset:280}50%{stroke-dashoffset:75;transform:rotate(135deg)}' +
    '100%{stroke-dashoffset:280;transform:rotate(450deg)}}';
  document.head.appendChild(style);

  var SPINNER = '<svg viewBox="0 0 66 66" aria-hidden="true" focusable="false"><circle cx="33" cy="33" r="30"></circle></svg>';
  var clicked = null, clickedAt = 0, active = null, safety = null;

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-action="add-to-cart"]');
    if (!btn) return;
    clicked = btn;
    clickedAt = Date.now();
  }, true);

  function stop() {
    if (safety) { clearTimeout(safety); safety = null; }
    if (active) {
      active.classList.remove('cm-atc-loading');
      active.style.removeProperty('--cm-atc-color');
      active.removeAttribute('aria-busy');
      var s = active.querySelector('.cm-atc-spinner');
      if (s) s.parentNode.removeChild(s);
      active = null;
    }
  }

  document.addEventListener('theme:loading:start', function () {
    if (!clicked || Date.now() - clickedAt > 1000) return;
    stop();
    active = clicked;
    clicked = null;
    active.style.setProperty('--cm-atc-color', getComputedStyle(active).color);
    var s = document.createElement('span');
    s.className = 'cm-atc-spinner';
    s.innerHTML = SPINNER;
    active.appendChild(s);
    active.setAttribute('aria-busy', 'true');
    active.classList.add('cm-atc-loading');
    safety = setTimeout(stop, 15000);
  });

  document.addEventListener('theme:loading:end', stop);
})();
